import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import {
  collection,
  getDocs,
  doc,
  addDoc,
  query,
  where
} from "firebase/firestore";

export default function AttendancePage() {
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [students, setStudents] = useState([]);
  const [attendance, setAttendance] = useState({});
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );


  // 🔥 Fetch batches
  useEffect(() => {
    const fetchBatches = async () => {
      const snap = await getDocs(collection(db, "batches"));
      setBatches(
        snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    };
    fetchBatches();
  }, []);

  // 🔥 Load students of selected batch
  const loadBatchStudents = async (batch) => {
    setSelectedBatch(batch);

    const snap = await getDocs(collection(db, "students"));

    const allStudents = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const filtered = allStudents.filter((s) =>
      batch.selectedStudents.includes(s.id)
    );

    setStudents(filtered);

    // default present
    const initial = {};
    filtered.forEach((s) => {
      initial[s.id] = "present";
    });

    setAttendance(initial);
  };

  // 🔄 Toggle
  const toggleAttendance = (id) => {
    setAttendance((prev) => ({
      ...prev,
      [id]: prev[id] === "present" ? "absent" : "present",
    }));
  };

  // 💾 Save attendance
  const handleSave = async () => {
    const records = students.map((s) => ({
      studentId: s.id,
      name: s.fullName,
      status: attendance[s.id],
    }));


    const q = query(
      collection(db, "attendance"),
      where("batchId", "==", selectedBatch.id),
      where("date", "==", selectedDate)
    );

    const snap = await getDocs(q);

    if (!snap.empty) {
      alert("Attendance already exists for this date ❌");
      return;
    }


    await addDoc(collection(db, "attendance"), {
      batchId: selectedBatch.id,
      batchName: selectedBatch.name,
      date: selectedDate,
      records,
      createdAt: new Date(),
    });

    alert("Attendance Saved ✅");
  };

  return (
    <div className="p-6 text-white">

      <h1 className="text-2xl font-bold text-orange-500 mb-6">
        Attendance
      </h1>

      {/* 🔽 Batch Select */}
      <select
        onChange={(e) =>
          loadBatchStudents(
            batches.find((b) => b.id === e.target.value)
          )
        }
        className="p-3 bg-black/40 rounded mb-6"
      >
        <option>Select Batch</option>
        {batches.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        ))}
      </select>

      <input
        type="date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        className="p-3 bg-black/40 rounded mb-6 ml-4"
      />

      {/* 👥 Students */}
      {students.length > 0 && (
        <div className="space-y-3">

          {students.map((s) => (
            <div
              key={s.id}
              className="flex justify-between items-center bg-white/10 p-4 rounded"
            >
              <span>{s.fullName}</span>

              <button
                onClick={() => toggleAttendance(s.id)}
                className={`px-4 py-1 rounded ${attendance[s.id] === "present"
                  ? "bg-green-500"
                  : "bg-red-500"
                  }`}
              >
                {attendance[s.id]}
              </button>
            </div>
          ))}

          <button
            onClick={handleSave}
            className="bg-orange-500 px-6 py-2 mt-4 rounded"
          >
            Save Attendance
          </button>

        </div>
      )}

    </div>
  );
}